'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002e$002dFunction1 from "./scala.-Function1.js";
import * as $j_scala$002escalajs$002ejs$002etimers$002epackage$0024 from "./scala.scalajs.js.timers.package$.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction0$002e$0024$0024$002dLambda$00242bf0f8dc580d6edeb2d6a336c52a1bab3049702d from "./scala.scalajs.runtime.-Anon-Function0.$$-Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d.js";
import * as $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1 from "./scala.scalajs.runtime.-Anon-Function1.$$-Lambda$412915ce24663401f4bc24349a746e1dbd693dc1.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_airstream_core_AirstreamError$() {
  this.yj = null;
  this.DA = null;
  this.DB = null;
  $n_Lcom_raquo_airstream_core_AirstreamError$ = this;
  this.yj = $j_java$002elang$002e$002dObject.$m_scm_Buffer$().x0($j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().aC(new ($j_scala$002e$002dFunction1.$d_F1.r().C)([])));
  this.DA = new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((err) => {
    try {
      console.error(((this.kT(err) + "\n") + this.UU(err, "\n")));
    } catch (e) {
      var e$2 = ((e instanceof $j_java$002elang$002e$002dObject.$c_jl_Throwable) ? e : new $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException(e));
      console.error("Error in AirstreamError.consoleErrorCallback:");
      console.error(e$2);
    }
  }));
  this.DB = new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction1$002e$0024$0024$002dLambda$0024412915ce24663401f4bc24349a746e1dbd693dc1.$c_sjsr_AnonFunction1_$$Lambda$412915ce24663401f4bc24349a746e1dbd693dc1(((err$2) => {
    console.warn("Using unsafe rethrow error callback. Note: other registered error callbacks might not run. Use with caution.");
    var $x_1 = err$2;
    throw (($x_1 instanceof $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException) ? $x_1.aZ : $x_1);
  }));
  this.WP(this.DA);
}
export { $c_Lcom_raquo_airstream_core_AirstreamError$ as $c_Lcom_raquo_airstream_core_AirstreamError$ };
$p = $c_Lcom_raquo_airstream_core_AirstreamError$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_airstream_core_AirstreamError$;
/** @constructor */
function $h_Lcom_raquo_airstream_core_AirstreamError$() {
}
export { $h_Lcom_raquo_airstream_core_AirstreamError$ as $h_Lcom_raquo_airstream_core_AirstreamError$ };
$h_Lcom_raquo_airstream_core_AirstreamError$.prototype = $p;
$p.kT = (function(e) {
  try {
    var errorMessage = e.ii();
  } catch (e$2) {
    var errorMessage = "(Unable to get the message for this error - exception occurred in its getMessage)";
  }
  return (($j_java$002elang$002e$002dObject.$objectGetClass(e).kW() + ": ") + errorMessage);
});
$p.UU = (function(err, newline) {
  try {
    return $j_java$002elang$002e$002dObject.$f_sc_IterableOnceOps__mkString__T__T__T__T($j_java$002elang$002e$002dObject.$m_s_Predef$().iy(err.UV()), "", newline, "");
  } catch (e) {
    return "(Unable to get the stacktrace for this error - exception occurred in its getStackTrace)";
  }
});
$p.SN = (function(message, cause) {
  return ((message + "; cause: ") + (cause.k() ? $j_java$002elang$002e$002dObject.$m_s_None$() : new $j_java$002elang$002e$002dObject.$c_s_Some(this.kT(cause.C()))));
});
$p.WP = (function(fn) {
  this.yj.aG(fn);
});
$p.eb = (function(err) {
  var this$1 = this.yj;
  var it = this$1.s();
  while (it.i()) {
    var x0 = it.e();
    try {
      x0.j(err);
    } catch (e) {
      var e$2 = ((e instanceof $j_java$002elang$002e$002dObject.$c_jl_Throwable) ? e : new $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException(e));
      var x$2 = this.DB;
      if (((x0 === null) ? (x$2 === null) : x0.f(x$2))) {
        throw ((e$2 instanceof $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException) ? e$2.aZ : e$2);
      }
      console.warn("Error processing an unhandled error callback:");
      $j_scala$002escalajs$002ejs$002etimers$002epackage$0024.$m_sjs_js_timers_package$().XA(0.0, new $j_scala$002escalajs$002eruntime$002e$002dAnon$002dFunction0$002e$0024$0024$002dLambda$00242bf0f8dc580d6edeb2d6a336c52a1bab3049702d.$c_sjsr_AnonFunction0_$$Lambda$2bf0f8dc580d6edeb2d6a336c52a1bab3049702d(((e$2) => (() => {
        throw ((e$2 instanceof $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException) ? e$2.aZ : e$2);
      }))(e$2)));
    }
  }
});
var $d_Lcom_raquo_airstream_core_AirstreamError$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_airstream_core_AirstreamError$, "com.raquo.airstream.core.AirstreamError$", ({
  gJ: 1,
  e: 1,
  aa: 1
}));
export { $d_Lcom_raquo_airstream_core_AirstreamError$ as $d_Lcom_raquo_airstream_core_AirstreamError$ };
var $n_Lcom_raquo_airstream_core_AirstreamError$;
function $m_Lcom_raquo_airstream_core_AirstreamError$() {
  if ((!$n_Lcom_raquo_airstream_core_AirstreamError$)) {
    $n_Lcom_raquo_airstream_core_AirstreamError$ = new $c_Lcom_raquo_airstream_core_AirstreamError$();
  }
  return $n_Lcom_raquo_airstream_core_AirstreamError$;
}
export { $m_Lcom_raquo_airstream_core_AirstreamError$ as $m_Lcom_raquo_airstream_core_AirstreamError$ };
